import styled, { css } from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';
import { Body1, Title2 } from '../../components/typography';
import { useWidgetDimensions } from '../../widget-dimensions-provider';
import { TextShortener } from '../text-shortener';

type ServiceCardContentProps = {
  name: string;
  description: string;
};

export const ServiceCardOverview = ({
  name,
  description
}: ServiceCardContentProps) => {
  const { t } = useLingui();
  const { isMobile } = useWidgetDimensions();

  return (
    <Content>
      <TitleRow>
        <Title _isMobile={isMobile}>{name || t`Service`}</Title>
      </TitleRow>

      {description && isMobile ? (
        <TextShortener text={description} messageSeeMoreButton={t`more`} />
      ) : (
        <Description dangerouslySetInnerHTML={{ __html: description }} />
      )}
    </Content>
  );
};

const Content = styled.div.attrs({
  className: createReadableClass({
    component: 'service-card-overview',
    element: 'content'
  })
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;

const TitleRow = styled.div.attrs({
  className: createReadableClass({
    component: 'service-card-overview',
    element: 'title-row'
  })
})`
  display: flex;
  justify-content: space-between;
`;

const Title = styled(Title2).attrs({
  className: createReadableClass({
    component: 'service-card-overview',
    element: 'title'
  })
})<{ _isMobile: boolean }>`
  ${({ _isMobile }) =>
    _isMobile &&
    css`
      font-size: 15px;
      line-height: 20px;
    `}
`;

const Description = styled(Body1).attrs({
  className: createReadableClass({
    component: 'service-card-overview',
    element: 'description'
  })
})`
  word-break: break-word;
  overflow-wrap: break-word;
`;
